import { createContext } from "react";

const MetadataContext = createContext({
  metadata: {
    heroText: "",
    tabs: [],
    resultsFields2: [],
    sortby: [],
    filters: {},
  },
  title: "",
  favicon: "",
  setMetadata: () => {},
  isLoading: true,
});

export default MetadataContext;
